import React, { useState } from "react";

import { useApolloClient, useQuery } from "@apollo/client";
import { Notifications as NotificationIcon } from "@mui/icons-material";
import {
  AppBar as MuiAppBar,
  Avatar,
  Box,
  ButtonBase,
  IconButton,
  Menu,
  MenuItem,
  styled,
  Toolbar,
} from "@mui/material";
import Cookies from "js-cookie";
import { NavLink, useNavigate } from "react-router-dom";
import { withStyles } from "tss-react/mui";

import { persistor } from "@/client";
import { graphql } from "@/gql";
import { colors } from "@/theme/overrides/colors";

import nutricoachLogo from "../assets/Nutricoach.png";

export const APP_BAR_HEIGHT = 60;

const StyledAppBar = styled(MuiAppBar)(({ theme }) => ({
  borderBottomLeftRadius: theme.spacing(4),
  borderBottomRightRadius: theme.spacing(4),
  height: APP_BAR_HEIGHT,
  "&.MuiAppBar-colorPrimary": {
    backgroundColor: colors.white,
  },
}));

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  height: APP_BAR_HEIGHT,
  "&>img": {
    height: 50,
    width: 150,
  },
}));

const NotificationButton = withStyles(IconButton, {
  root: {
    marginRight: "26px",
  },
});

interface Props {
  left?: React.ReactNode;
}

const appBarQuery = graphql(`
  query AppBar {
    coachViewer {
      id
      profile {
        id
        fullName
        avatarUrl
      }
    }
  }
`);

const AppBar: React.FC<Props> = ({ left }) => {
  const client = useApolloClient();
  const navigate = useNavigate();
  const { data } = useQuery(appBarQuery);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleNavigateToNotificationPage = () => navigate("/notification");
  const logout = () => {
    client.clearStore();
    persistor.purge();
    Cookies.remove("token");
    window.location.assign("/login");
  };

  return (
    <>
      <StyledAppBar elevation={0}>
        <StyledToolbar>
          <img src={nutricoachLogo} alt="nutricoach logo" />
          {left}
          <Box marginLeft="auto">
            <NotificationButton
              size="large"
              onClick={handleNavigateToNotificationPage}
            >
              <NotificationIcon color="primary" />
            </NotificationButton>
            <ButtonBase onClick={handleProfileMenuOpen}>
              <Avatar
                src={data?.coachViewer.profile?.avatarUrl ?? undefined}
                alt={`${data?.coachViewer.profile?.fullName} photo`}
              >
                {data?.coachViewer.profile?.fullName.charAt(0)}
              </Avatar>
            </ButtonBase>
          </Box>
        </StyledToolbar>
      </StyledAppBar>
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        <MenuItem component={NavLink} to="/profile" onClick={handleMenuClose}>
          My Profile
        </MenuItem>
        <MenuItem
          component={NavLink}
          to="/subscription"
          onClick={handleMenuClose}
        >
          My Subscription
        </MenuItem>
        <MenuItem onClick={logout}>Logout</MenuItem>
      </Menu>
    </>
  );
};

export default AppBar;
